import React, { useEffect, useState } from "react";
import { Input, Modal, notification, Spin } from "antd";
import CheckUserPinSma from "functions/user/checkUserPinSma";

const AskUserPinSma = ({ userId, open, close, verified, show = false }) => {
  const [writedPin, setWritedPin] = useState(["", "", "", "", "", ""]);
  const [checking, setChecking] = useState(false);
  useEffect(() => {
    // check if writedPin join matches pin
    if (String(writedPin.join("")).length === 6) {
      checkPin();
    }
  }, [writedPin]);
  const checkPin = async () => {
    setChecking(true);
    try {
      const result = await CheckUserPinSma(userId, writedPin.join(""));
      if (result) {
        verified("SMA");
        close();
      } else
        notification.error({
          message: "Пин код буруу байна. Дахин оролдоно уу.",
        });
    } catch (err) {
      console.log(err);
      notification.error({
        message: "Пин код шалгахад алдаа гарлаа. Дахин оролдоно уу.",
      });
    } finally {
      setChecking(false);
    }
  };
  const handleChange = (value, index) => {
    if (/^\d?$/.test(value)) {
      const newPin = [...writedPin];
      newPin[index] = value;
      setWritedPin(newPin);

      // auto move focus
      if (value && index < 5) {
        document.getElementById(`pin-${index + 1}`).focus();
      }
    }
  };

  const handleBackspace = (e, index) => {
    if (e.key === "Backspace" && !writedPin[index] && index > 0) {
      document.getElementById(`pin-${index - 1}`).focus();
    }
  };
  return (
    <Modal open={open} size={350} onCancel={close} footer={null}>
      <div className="flex flex-col items-center gap-6 py-6 justify-center">
        <div className="addCarTitle">
          <span className="flex items-center gap-2 flex-row">
            <img src="/smaLogo.png" width={40} />
            Та 6 оронтой PIN код оо оруулна уу
          </span>
        </div>
        <Spin spinning={checking}>
          <div className="flex gap-3">
            {writedPin.map((digit, index) => (
              <Input
                key={index}
                id={`pin-${index}`}
                value={digit}
                inputMode="numeric"
                maxLength={1}
                type="password"
                onChange={(e) => handleChange(e.target.value, index)}
                onKeyDown={(e) => handleBackspace(e, index)}
                className="w-11 h-11 text-center text-lg font-bold rounded-xl border-2 border-gray-300 focus:border-blue-500"
              />
            ))}
          </div>
        </Spin>
      </div>
    </Modal>
  );
};

export default AskUserPinSma;
